module.exports = __webpack_public_path__ + "img/accessory.6cd24bec.png";